import { render } from "./RegisterPanel.vue?vue&type=template&id=fdf1c250"
import script from "./RegisterPanel.vue?vue&type=script&lang=js"
export * from "./RegisterPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__